import { HiSparkles } from 'react-icons/hi2';
import { ChatLauncher } from '@reloam/ui';

interface AssistantLauncherProps {
  onOpen: () => void;
  /** Unread messages across all conversations. */
  unread?: number;
}

/** Floating button: the one way to open the shared chat panel from any page. */
export default function AssistantLauncher({ onOpen, unread = 0 }: AssistantLauncherProps) {
  return <ChatLauncher onOpen={onOpen} unread={unread} label="Ask AI" ariaLabel="Open messages and assistant" icon={HiSparkles} />;
}
